import {EActionStatus} from '@app/shared/enums/action-status.enum';
import {createAction, props} from '@ngrx/store';
import {IAccountFormPayload, IEditAccountDetails, IOrganizationPayload} from '../models/accounts.model';
import {ICustomerRequest} from '../models/customer-request.model';
import {ICustomerResponse} from '../models/customer-response.model';
import {IRole} from '../models/role.model';

export enum AccountsActions {
  Customers = '[Customers Component] Customers',
  CustomersSuccess = '[Customers Effects] Customers Success',
  CustomersFailure = '[Customers Effects] Customers Failure',
  CustomersError = '[Customers Effects] Customers Error',
  LoadRoles = '[Add Account Component] get roles',
  LoadRolesSuccess = '[Accounts effect] get roles success',
  LoadRolesFailure = '[Accounts effect] get roles failure',
  SaveAccount = '[Add Account Component] save account',
  SaveAccountSuccess = '[Accounts effect] save account success',
  SaveAccountFailure = '[Accounts effect] save account failure',
  ResetAddAccountStatus = '[Add account component] Reset add account status',
  UpdateAddAccountStatus = '[Add account component] Update add account status',
  UpdateAccount = '[Edit Account Component] Update account',
  UpdateAccountSuccess = '[Accounts effect] Update account success',
  UpdateAccountFailure = '[Accounts effect] Update account failure',
  ResetUpdateAccountStatus = '[Edit account component] Reset update account status',
  UpdateAccountStatus = '[Edit account component] update account status',
  LoadEditCustomerAccountDetails = '[Edit Account Component] load edit account customer details',
  LoadEditCustomerAccountDetailsSuccess = '[Accounts effect] load edit account customer details success',
  LoadEditCustomerAccountDetailsFailure = '[Accounts effect] load edit account customer details failure',
  UpdateOrganization = '[Edit Account Component] Update organization',
  UpdateOrganizationSuccess = '[Accounts effect] Update organization success',
  UpdateOrganizationFailure = '[Accounts effect] Update organization failure',
  ResetUpdateOrganizationStatus = '[Edit institution component] Reset update organization status',
}
export const customersAction = createAction(AccountsActions.Customers, props<{request: ICustomerRequest}>());
export const customersEffectSuccess = createAction(
  AccountsActions.CustomersSuccess,
  props<{response: ICustomerResponse}>()
);
export const customersEffectFailure = createAction(AccountsActions.CustomersFailure, props<{reason: string}>());
export const customersEffectError = createAction(AccountsActions.CustomersError, props<{error: string}>());

export const loadRoles = createAction(AccountsActions.LoadRoles);
export const loadRolesSuccess = createAction(AccountsActions.LoadRolesSuccess, props<{roles: IRole[]}>());
export const loadRolesFailure = createAction(AccountsActions.LoadRolesFailure);

export const saveAccount = createAction(AccountsActions.SaveAccount, props<{payload: IAccountFormPayload}>());

export const saveAccountSuccess = createAction(AccountsActions.SaveAccountSuccess, props<{status: EActionStatus}>());

export const saveAccountFailure = createAction(AccountsActions.SaveAccountFailure, props<{status: EActionStatus}>());

export const resetAddAccountStatus = createAction(AccountsActions.ResetAddAccountStatus);

export const updateAddAccountStatus = createAction(
  AccountsActions.UpdateAddAccountStatus,
  props<{status: EActionStatus}>()
);

export const updateAccount = createAction(AccountsActions.UpdateAccount, props<{payload: IAccountFormPayload}>());

export const updateAccountSuccess = createAction(
  AccountsActions.UpdateAccountSuccess,
  props<{status: EActionStatus}>()
);

export const updateAccountFailure = createAction(
  AccountsActions.UpdateAccountFailure,
  props<{status: EActionStatus}>()
);

export const resetUpdateAccountStatus = createAction(AccountsActions.ResetUpdateAccountStatus);

export const updateAccountStatus = createAction(AccountsActions.UpdateAccountStatus, props<{status: EActionStatus}>());

export const loadEditCustomerAccountDetails = createAction(
  AccountsActions.LoadEditCustomerAccountDetails,
  props<{customerId: string; organizationId: number}>()
);

export const loadEditCustomerAccountDetailsSuccess = createAction(
  AccountsActions.LoadEditCustomerAccountDetailsSuccess,
  props<{editCustomerAccountInfo: IEditAccountDetails}>()
);

export const loadEditCustomerAccountDetailsFailure = createAction(
  AccountsActions.LoadEditCustomerAccountDetailsFailure
);

export const updateOrganization = createAction(
  AccountsActions.UpdateOrganization,
  props<{payload: IOrganizationPayload}>()
);

export const updateOrganizationSuccess = createAction(
  AccountsActions.UpdateOrganizationSuccess,
  props<{status: EActionStatus}>()
);

export const updateOrganizationFailure = createAction(AccountsActions.UpdateOrganizationFailure);

export const resetUpdateOrganizationStatus = createAction(AccountsActions.ResetUpdateOrganizationStatus);
